// The custom-form pages run JavaScript that expects a full page load (see the FullPageLoad controller concern). A
// Turbo Drive visit would fetch one of them only to find its turbo-visit-control "reload" meta and load it a second
// time, so visits to their paths become full page loads before Turbo fetches anything. A path missing here still
// loads in full through that meta, one request later.
//
// These are the path segments (config/routes.rb) of the controllers that include FullPageLoad.
const FULL_PAGE_LOAD_SEGMENTS = new Set([
  'amendments',
  'custom-form-editor',
  'discharges',
  'evaluations', // Also the admin evaluation view, /admin/evaluations.
  'intake-document', // The patient portal's.
  'intake-documents',
  'intake_documents', // Nested under /organizations/:id/patients/:id.
  'plans-of-care',
  'progress-reports',
  'supplementals',
  'visit-notes',
]);

export function requiresFullPageLoad(url) {
  const { pathname } = new URL(url, window.location.href);
  return pathname.split('/').some((segment) => FULL_PAGE_LOAD_SEGMENTS.has(segment));
}

const onFullPageLoadPage = () => document.documentElement.dataset.turbo === 'false';

// A link: cancelling turbo:click leaves the click alone, and the browser follows the link itself.
export function onTurboClick(event) {
  if (requiresFullPageLoad(event.detail.url)) event.preventDefault();
}

// Turbo.visit() calls (dropdown and table-row navigation, UJS redirects) have no link for the browser to follow.
// An earlier listener that cancelled the visit (the unsaved-changes confirm) wins.
export function onTurboBeforeVisit(event, navigate = (url) => window.location.assign(url)) {
  if (event.defaultPrevented) return;
  if (!onFullPageLoadPage() && !requiresFullPageLoad(event.detail.url)) return;

  event.preventDefault();
  navigate(event.detail.url);
}

document.addEventListener('turbo:click', onTurboClick);
document.addEventListener('turbo:before-visit', (event) => onTurboBeforeVisit(event));
